
import React from "react";
import { Loader2, Calendar, Clock } from "lucide-react";

export const LoadingState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4">
      <div className="relative">
        <Calendar className="h-12 w-12 text-[#00B6F0]/30" />
        <Loader2 className="h-6 w-6 text-[#00B6F0] animate-spin absolute top-3 left-3" />
      </div>
      <div className="text-center space-y-2">
        <p className="text-white font-medium">Preparando agendamento</p>
        <p className="text-gray-400 text-sm">Carregando informações do mentor...</p>
      </div>
      
      {/* Skeleton loading indicators */}
      <div className="w-full space-y-3 mt-6">
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-[#223342] rounded animate-pulse"></div>
          <div className="h-3 bg-[#223342] rounded w-32 animate-pulse"></div>
        </div>
        <div className="flex items-center space-x-2">
          <Clock className="w-4 h-4 text-[#00B6F0]/50" />
          <div className="h-3 bg-[#223342] rounded w-40 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
